/**
 * 打字机效果
 */
export default class MessageManager {
  messageList: string[] = []
  timer: any = null
  timerDelay = 100
  onFinish: () => void
  onMessage: (message: string) => void
  stopFlag = false // 停止标志，如果设置了停止，但是队列没走完，就会等队列走完之后再停止

  constructor(
    options: {
      timerDelay?: number
      onMessage?: (message: string) => void
      onFinish?: () => void
    } = {}
  ) {
    const {
      timerDelay = 100,
      onMessage = () => {},
      onFinish = () => {}
    } = options
    this.timerDelay = timerDelay
    this.onFinish = onFinish
    this.onMessage = onMessage
  }

  start() {
    this.timer = setInterval(() => {
      if (this.messageList.length > 0) {
        this.consume()
      } else {
        if (this.stopFlag) {
          this.immediatelyStop()
        }
      }
    }, this.timerDelay)
  }

  consume() {
    if (this.messageList.length > 0) {
      let count = Math.ceil(this.messageList.length / 10)
      const str = this.messageList.splice(0, count).join('')
      console.log(this.messageList.length, this.messageList.join(''))
      str && this.onMessage(str)
    }
  }

  add(str: string) {
    if (!str) return
    const strChars = str.split('')
    this.messageList = [...this.messageList, ...strChars]
  }

  stop() {
    this.stopFlag = true
  }

  immediatelyStop() {
    // 立刻停止
    clearInterval(this.timer)
    this.timer = null
    this.messageList = []
    this.onFinish()
  }
}
